import { ReactNode } from 'react';
import { Loader } from '../Loader/LoaderViewTwo';

export interface LoadingModalProps {
  text?: string;
  show: boolean;
  children?: ReactNode;
}

export function LoadingModal(props: LoadingModalProps) {
  const { text, show, children } = props;

  if (!show) return null;

  return (
    <div className="w-full !h-full fixed inset-0 z-10 flex justify-center items-center gap-2.5 bg-gray-700/20 backdrop-blur-[25px]">
      <div className="flex justify-center items-center w-[32rem]">
        <div className="flex flex-col items-center gap-2">
          {children || (
            <>
              <Loader size="3.5rem" />
              <p className="text-gray-700 text-center text-lg">{text}</p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
